import React from 'react'
import { Box, Typography, makeStyles, Theme } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        minHeight: 200,
        padding: theme.spacing(4),
        textAlign: 'center',
        gap: theme.spacing(1),
    },
    title: {
        fontWeight: 600,
        fontSize: '1rem',
    },
    hint: {
        color: theme.palette.text.secondary,
        fontSize: '0.875rem',
        maxWidth: 420,
        lineHeight: 1.5,
    },
}))

/** Placeholder for Setup tabs that are not wired yet. */
export const SetupTabPlaceholder: React.FC<{
    title: string
    description?: string
}> = ({ title, description }) => {
    const classes = useStyles()
    return (
        <Box className={classes.root}>
            <Typography className={classes.title}>{title}</Typography>
            <Typography className={classes.hint}>
                {description ??
                    'Configuration for this area will live here. Nothing to set up yet.'}
            </Typography>
        </Box>
    )
}
